import React from 'react';

import i18n from '../../i18n';

// @mui
import { Box, TextField, Typography } from '@mui/material';

export default class DialogTextField extends React.Component {
    render() {
        // field, value, cache, onChange
        let show = this.props.field.show;
        let value = this.props.value?.[show] || this.props.value;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const onlyRead = !!this.props.field.onlyRead;

        if (onlyRead) {
            // Render as a Typography component if onlyRead is true
            // Show the translated name and value
            return (
                <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="body2" color="textSecondary">
                        {translatedName}:
                    </Typography>
                    {value ? (
                        <Typography variant="body1" color="textPrimary">
                            {value}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            {i18n.t('common.notSet')}
                        </Typography>
                    )}
                </Box>
            );
        }

        return (
            <TextField
                key={this.props.field.id}
                autoFocus
                margin="dense"
                id={this.props.field.id}
                label={translatedName}
                type="text"
                value={value || ''}
                fullWidth
                onChange={(event) =>
                    this.props.onChange(event.target.id, event.target.value)
                }
            />
        );
    }
}
